<template>
  <b-card
    header="Season"
    class="season"
  >
    <table class="props mb-3">
      <tr>
        <th>Id</th>
        <td>{{season.id}}</td>
      </tr>
      <tr>
        <th>Proto</th>
        <td>{{season.proto_id | getProtoStr}}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td :class="statusClass">
          {{season.status | getSeasonStatusName}}
        </td>
      </tr>
      <tr>
        <th>Created at</th>
        <td>{{season.ctime | getMomentStr}}</td>
      </tr>
    </table>

    <table class="table table-bordered table-sm mb-0 text-nowrap">
      <thead>
        <tr>
          <th></th>
          <th>Start</th>
          <th>Finish</th>
          <th>Duration</th>
        </tr>
      </thead>
      <tr>
        <th>Planned</th>
        <td>{{season.stime | getMomentStr}}</td>
        <td>{{season.ftime | getMomentStr}}</td>
        <td>{{plannedDurationStr}}</td>
      </tr>
      <tr>
        <th>Real</th>
        <td>{{season.srtime | getMomentStr}}</td>
        <td>{{season.frtime | getMomentStr}}</td>
        <td>{{realDurationStr}}</td>
      </tr>
    </table>
  </b-card>
</template>

<script>
import { getSeasonStatusName         } from '../model/season.js';
import { getSeasonStatusClass        } from '../model/season.js';
import { getSeasonPlannedDurationStr } from '../model/season.js';
import { getSeasonRealDurationStr    } from '../model/season.js';

export default {
  name: 'PlayerSeason',

  props: {
    season: {
      type: Object,
      required: true,
    }
  },

  computed: {
    statusClass() {
      return getSeasonStatusClass(this.season.status);
    },

    plannedDurationStr() {
      return getSeasonPlannedDurationStr(this.season);
    },

    realDurationStr() {
      return getSeasonRealDurationStr(this.season);
    },
  },

  filters: {
    getSeasonStatusName,
  },
}
</script>

<style scoped>
.season .card-header,
.season .card-body {
  padding: 10px;
}

.season table.props > tr > th {
  padding-right: 0.5em;
}

.season table.props > tr > th,
.season table.props > tr > td {
  padding-bottom: 0.2rem;
}

.season table.props > tr:last-child > th,
.season table.props > tr:last-child > td {
  padding-bottom: 0rem;
}
</style>
